export class ReduxPromiseChain {
  constructor({ dispatch, promises = [], dispatchMap = [], catchFunc }) {
    this.dispatch = dispatch;
    this.promises = promises;
    this.dispatchMap = dispatchMap;
    this.error = false;
    this.catchFunc = catchFunc;

    if (!dispatch && typeof dispatch === 'function') {
      console.error('ReduxPromiseChain requires the dispatch function!');
      this.error = true;
    }
  }

  start() {
    return new Promise((resolve, reject) => {
      Promise.all(this.promises)
        .then(values => {
          this.dispatchPayloads(values);
          resolve(values);
        })
        .catch(reason => {
          if (this.catchFunc) {
            this.catchFunc(reason);
          }
        });
    });
  }

  dispatchPayloads = values => {
    if (!this.error) {
      values.forEach((response, index) => {
        switch (typeof this.dispatchMap[index]) {
          case 'string':
            this.dispatch({
              type: this.dispatchMap[index],
              payload: response,
            });
            break;
          case 'function':
            this.dispatchMap[index](response);
            break;
          default:
            console.warn(
              'Unsupported dispatchMap type. Must be a string or function.',
              `Supplied: ${typeof this.dispatchMap[index]}`
            );
        }
      });
    }

    return values;
  };
}



// WEBPACK FOOTER //
// ./src/common/ReduxPromiseChain.js